/**
 * Official SevenRooms reservation widget.
 * One init, all [data-sevenrooms-book] triggers.
 * Does not poll the widget DOM. Does not use MutationObserver.
 * If the embed fails, Book hrefs continue to SevenRooms.
 */
(function () {
  "use strict";

  var config = window.CHATERS_SEVENROOMS;
  if (!config || !config.venueId || !config.embedSrc) return;
  if (window.__chatersSevenrooms) return;
  window.__chatersSevenrooms = true;

  var ready = false;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener(
    "click",
    function (event) {
      var link =
        event.target && event.target.closest
          ? event.target.closest("a[data-sevenrooms-book]")
          : null;
      if (!link) return;
      if (!ready) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;

      event.preventDefault();

      var label = link.getAttribute("data-sevenrooms-label") || "";
      if (!label) {
        label = String(link.textContent || "").replace(/\s+/g, " ").trim();
      }

      window.dataLayer.push({
        event: "chaters_booking_widget_open",
        ctaLabel: label,
        sourcePage: config.pagePath || window.location.pathname
      });
    },
    true
  );

  function initWidget() {
    if (!window.SevenroomsWidget || typeof window.SevenroomsWidget.init !== "function") {
      return false;
    }
    if (!document.querySelector("[data-sevenrooms-book]")) {
      return false;
    }

    try {
      window.SevenroomsWidget.init({
        venueId: config.venueId,
        triggerSelector: "[data-sevenrooms-book]",
        type: "reservations",
        styleButton: false
      });
      ready = true;
      return true;
    } catch (err) {
      ready = false;
      return false;
    }
  }

  function loadEmbed() {
    if (window.SevenroomsWidget) {
      initWidget();
      return;
    }

    var script = document.createElement("script");
    script.src = config.embedSrc;
    script.async = true;
    script.onload = function () {
      initWidget();
    };
    script.onerror = function () {
      ready = false;
    };
    document.head.appendChild(script);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadEmbed);
  } else {
    loadEmbed();
  }
})();
